import React from 'react';
import { NavLink } from 'react-router-dom';

/**
 * Tabs
 * ------------------------------------------------------------------
 * Horizontal tab switcher with optional icons and pill-style active
 * background. Fully controlled via `activeKey`, or use `item.to` for
 * route-based navigation with NavLink.
 *
 * @param {{key: string, label: string, icon?: string, count?: number, to?: string}[]} items
 * @param {string} activeKey
 * @param {function} onChange - (key) => void — ignored when item.to is set
 */
const Tabs = ({ items = [], activeKey, onChange }) => (
  <div className="tabs" role="tablist">
    {items.map((item) => {
      const content = (
        <>
          {item.icon && <img src={item.icon} alt="" className="tabs__icon" />}
          <span className="tabs__label">{item.label}</span>
          {typeof item.count === 'number' && (
            <span
              className={`tabs__count${
                item.countTone ? ` tabs__count--${item.countTone}` : ''
              }`}
            >
              {item.count}
            </span>
          )}
        </>
      );

      if (item.to) {
        return (
          <NavLink
            key={item.key}
            to={item.to}
            role="tab"
            data-key={item.key}
            aria-selected={item.key === activeKey}
            className={({ isActive }) => {
              const active =
                activeKey != null && activeKey !== ""
                  ? item.key === activeKey
                  : isActive
              return `tabs__item ${active ? "tabs__item--active" : ""}`
            }}
          >
            {content}
          </NavLink>
        );
      }

      return (
        <button
          key={item.key}
          type="button"
          role="tab"
          data-key={item.key}
          aria-selected={item.key === activeKey}
          className={`tabs__item ${item.key === activeKey ? 'tabs__item--active' : ''}`}
          onClick={() => onChange?.(item.key)}
        >
          {content}
        </button>
      );
    })}
  </div>
);

export default Tabs;
